import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { IMFAConfigList } from './../model/mfa.interface';

export interface Color {
  name: string,
  hex: string,
  darkContrast: boolean
}
@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  // variable declaration
  isRegistrationEnabled:boolean = false;
  private requestId = new BehaviorSubject<string>('');
  private baseDomain = new BehaviorSubject<string>('');
  private clientInfo = new BehaviorSubject<any>({});
  private user = new BehaviorSubject<string>('');
  private mfaList = new BehaviorSubject<any>({});
  private isTranslationsLoaded = new BehaviorSubject<boolean>(false);
  private isAppUser = new BehaviorSubject<boolean>(false);

  currentClientInfo = this.clientInfo.asObservable();

  private primaryColor = new BehaviorSubject('#f7941d');
  currentPrimaryColor = this.primaryColor.asObservable();

  private secondaryColor = new BehaviorSubject('#ef4923');
  currentSecondaryColor = this.secondaryColor.asObservable();

  private algorithm = new BehaviorSubject('default');
  currentAlgorithm = this.algorithm.asObservable();

  private providerList: any;

  // constructor
  constructor() {}


  setProviderData(data: any) {
    this.providerList = data;
  }

  getProviderData() {
    return this.providerList;
  }

  // property methods

  // get requestId
  _getRequestId = () => {
    return this.requestId.asObservable();
  };

  // set requestId
  _setRequestId = (request_id: string) => {
    this.requestId.next(request_id);
  };

  // get baseURL
  _getBaseURL = () => {
    return this.baseDomain.asObservable();
  };

  // set baseURL
  _setBaseURL = (url: string) => {
    this.baseDomain.next(url);
  };

  // get ClientInfo
  _getClientInfo = () => {
    return this.clientInfo.asObservable();
  };

  // set ClientInfo
  _setClientInfo = (clientInfo: any) => {
    if(clientInfo){
      this.clientInfo.next(clientInfo);
    }
  };

  // get User
  _getUser = () => {
    return this.user.asObservable();
  };

  // set User
  _setUser = (user: string) => {
    this.user.next(user);
  };

  // get mfaList
  _getMFAList = () => {
    return this.mfaList.asObservable();
  };

  // set mfaList
  _setMFAList = (data: Partial<IMFAConfigList>) => {
    this.mfaList.next(data);
  };

  _clearMFAList = () =>{
    this.mfaList.next(EMPTY);
  }

  changePrimaryColor(primaryColor: string) {
    this.primaryColor.next(primaryColor);
  }

  changeSecondaryColor(secondaryColor: string) {
    this.secondaryColor.next(secondaryColor);
  }

  changeAlgorithm(algorithm: string) {
    this.algorithm.next(algorithm);
  }

  _getTranslationLoadStatus = () =>{
    return this.isTranslationsLoaded.asObservable();
  }

  _setTranslationLoadStatus = (status:boolean) =>{
    this.isTranslationsLoaded.next(status);
  }

    _getIsAppUser = () =>{
        return this.isAppUser.asObservable();
    }

    _setIsAppUser = (status:boolean) =>{
        this.isAppUser.next(status);
    }

}
